if (typeof __tcfapi !== 'undefined') {
    __tcfapi('getTCData', 2, (tcData, success) => {
        consenTag.init({
            containerId: "66628681",
            silentMode: true,
        }, success ? tcData.tcString : false);
    });
}
